
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[[...orgPage]]",
      function () {
        return require("private-next-pages/account/[[...orgPage]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/[[...orgPage]]"])
      });
    }
  